import { render, staticRenderFns } from "./AddBlockTool.vue?vue&type=template&id=60e6fcad&scoped=true&lang=pug&"
import script from "./AddBlockTool.vue?vue&type=script&lang=js&"
export * from "./AddBlockTool.vue?vue&type=script&lang=js&"
import style0 from "./AddBlockTool.vue?vue&type=style&index=0&id=60e6fcad&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e6fcad",
  null
  
)

export default component.exports